import React, { useEffect } from 'react'

import NotFound from '../../components/404'
import {
    setNotFoundInRoutesAction,
    clearNotFoundInRoutesAction,
} from '../../reducers/actions/not-found-routes'

interface NotFoundRouteProps {
    routesType?: string
}

/**
 * Catch-all element used as the React Router 7 wildcard route.
 *
 * Marks the current route as not found in the redux store on mount,
 * and clears the flag on unmount.
 */
const NotFoundRoute = ({ routesType = 'globalRoutes' }: NotFoundRouteProps) => {
    useEffect(() => {
        setNotFoundInRoutesAction(routesType)
        return () => clearNotFoundInRoutesAction()
    }, [routesType])

    return <NotFound />
}

export default NotFoundRoute
